export const convertTimeAgo = (dateString: string) => {
  const now: any = new Date();
  const inputDate: any = new Date(dateString);

  const diffInSeconds = Math.floor((now - inputDate) / 1000);
  const diffInHours = Math.floor(diffInSeconds / 3600);
  const diffInDays = Math.floor(diffInSeconds / 86400);
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInYears > 0) {
    return `${diffInYears} ${diffInYears > 1 ? 'years' : 'year'}`;
  } else if (diffInMonths > 0) {
    return `${diffInMonths} month${diffInMonths > 1 ? 's' : ''}`;
  } else if (diffInDays > 0) {
    return `${diffInDays} ${diffInDays > 1 ? 'days' : 'day'}`;
  } else {
    return `${diffInHours} ${diffInHours > 1 ? 'year' : ''}`;
  }
};


// This function converts each word in a string to Title Case (First letter uppercase, rest lowercase)
export const toTitleCase = (text: string): string => {
  return text.replace(/\w\S*/g, (txt) => {
    // For each matched word:
    // - Get the first character and make it uppercase
    // - Get the rest of the word and make it lowercase
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  });
};

// Generate nano id 12 characters long
export const nanoId = () => {
  // 1. Generate 12 cryptographically secure random bytes
  const bytes = crypto.getRandomValues(new Uint8Array(12));

  // 2. Convert each byte to a base36 character (0-9, a-z)
  // - `b % 36` ensures the value stays within base36 range (0-35)
  // - `.toString(36)` converts that number to a base36 string
  // - `[...]` spreads the Uint8Array into a regular array so we can map it
  const id = [...bytes].map((b) => (b % 36).toString(36)).join('');

  // Return the final string of 12 characters
  return id;
};

// Get user's operating system
export const getOS = (): 'iOS' | 'Android' | 'Other' => {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/android/i.test(userAgent)) return 'Android';
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) return 'iOS';
  return 'Other';
};

// Adjust OS name to match the platform
export const adjustOSName = (os: string): string => {
  // Convert to lowercase first, then map to display name
  const osLower = os.toLowerCase();
  
  switch (osLower) {
    case 'ios':
      return 'iOS';
    case 'android': 
      return 'Android';
    case 'desktop':
      return 'Desktop';
    default:
      return toTitleCase(os);
  }
};
